import { makeStyles } from '@material-ui/core'
import AddPolicy from 'src/assets/PolicyDetails_Images/AddPolicy.svg'
import SmartBanner from 'src/components/Individual/MyPoliciesView/SmartBanner'
import {
  UploadPoliciesData,
  UploadPolicyInsuranceTypes,
} from 'src/utils/constants/MyPoliciesData'
import UploadPoliciesView from 'src/components/Individual/MyPoliciesView/Views/UploadPoliciesView'

const NoPoliciesView = ({ openUploadPolicy }) => {
  const classes = useStyles()

  const getUploadPoliciesTileData = () => {
    return UploadPoliciesData?.filter(
      (dataItem) =>
        dataItem?.insuranceType !== UploadPolicyInsuranceTypes?.others
    )
  }
  return (
    <div className={classes.mainContainer}>
      <div className={classes.addPolicyMainContainer}>
        <div className={classes.addPolicyContainer}>
          <div
            className={classes.buttonContainer}
            onClick={openUploadPolicy}
            id='openUploadPolicy'
          >
            <img
              src={AddPolicy}
              alt='addPolicy'
              className={classes.addPolicyImage}
            />
            <span className={classes.addPolicyText}>Add Personal Policies</span>
          </div>
        </div>
      </div>

      <div>
        <SmartBanner />
      </div>

      <div className={classes.bannerTextContainer}>
        <span className={classes.bannerText}>
          Already Got <b>Personal Policies?</b> Click &quot;<b>Upload Policy</b>
          &quot;
        </span>
        <span className={classes.bannerText}>
          {' '}
          to store and get personalized alerts.
        </span>
      </div>

      <div>
        <UploadPoliciesView
          uploadPoliciesList={getUploadPoliciesTileData()}
          openUploadPolicy={openUploadPolicy}
        />
      </div>
    </div>
  )
}

export default NoPoliciesView

const useStyles = makeStyles({
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    justifyContent: 'center',
    alignItems: 'center',
  },
  addPolicyContainer: {
    display: 'flex',
    justifyContent: 'center',
    padding: '10px 0px',
  },
  addPolicyMainContainer: {
    justifyContent: 'end',
    width: '100%',
  },
  buttonContainer: {
    border: ' 1px solid #B92250',
    borderRadius: '34px',
    padding: '8px 12px',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    cursor: 'pointer',
  },
  addPolicyImage: {
    width: '12px',
  },
  addPolicyText: {
    fontSize: '13px',
    fontWeight: '600',
    color: '#B92250',
    lineHeight: '15px',
  },
  bannerTextContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  bannerText: {
    fontSize: '21px',
  },
})
